<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12 text-center">
                <div class="text-center card-box">
                    <div class="pt-2 pb-2">
                        <img src="@assets/images/logo-sm.png"
                             class="rounded-circle img-thumbnail avatar-xl" alt="profile-image"/>

                        <h4 class="mt-3">
                            <p class="text-dark">{{user ? user.name : ''}}</p>
                        </h4>
                        <p class="text-muted">
                            <span class="text-dark">{{user ? user.email : ''}}</span>
                        </p>

                      <p v-if="login_status" class="text-muted">
                        <span class="text-dark">IP address : {{ login_status.ip }}</span>
                      </p>

                      <p v-if="login_status" class="text-muted">
                        <span class="text-dark">Last Login Date : {{ customDate(login_status.created_at) }}</span>
                      </p>

                        <router-link tag="a" to="/user/password/update" class="btn btn-light btn-sm waves-effect">Update Password</router-link>
                        <router-link tag="a" to="/user/profile/update" class="btn btn-light btn-sm waves-effect ml-1">Update Profile</router-link>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import http from "@state/http";
    import store from "../../../state/store";
    import moment from "moment";

    export default {
        page: {
            title: 'Profile',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: 'Profile',
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Profile',
                        active: true,
                    },
                ],

                user: "",
                login_status: '',
            }
        },
        mounted() {
            if (store.getters['auth/loggedIn']) {
                this.getUserProfile();
            }
        },
        methods: {
          customDate(date) {
            return moment.utc(date).local().format("L LT");
          },
            getUserProfile() {
                http.get("api/user/info")
                    .then(resource => {
                        this.user = resource.data.user
                       this.login_status = resource.data.login_status;
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
    }
</script>

